import { render, staticRenderFns } from "./Headerdefinition.vue?vue&type=template&id=367367b6&scoped=true"
import script from "./Headerdefinition.vue?vue&type=script&lang=js"
export * from "./Headerdefinition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367367b6",
  null
  
)

export default component.exports